import EventEmitter from '@/utils/EventEmitter'
import api from './api'
import { concantQuery } from '@/utils/concatQuery'

export const StatisticEventEmitter = new EventEmitter()

const wsEvents = {
  STATISTICAL_UPDATE_LIVE_AUCTIONS: 'STATISTICAL_UPDATE_LIVE_AUCTIONS',
  STATISTICAL_UPDATE_PENDING_UPPROVAL: 'STATISTICAL_UPDATE_PENDING_UPPROVAL',
  STATISTICAL_UPDATE_NEW_MESSAGE: 'STATISTICAL_UPDATE_NEW_MESSAGE',
  STATISTICAL_UPDATE_CLOSED_AUCTIONS: 'STATISTICAL_UPDATE_CLOSED_AUCTIONS',
  STATISTICAL_UPDATE_USERS_ONLINE: 'STATISTICAL_UPDATE_USERS_ONLINE',
  STATISTICAL_UPDATE_NEW_REGISTERED_USERS: 'STATISTICAL_UPDATE_NEW_REGISTERED_USERS',
  STATISTICAL_UPDATE_TODAY_SALES: 'STATISTICAL_UPDATE_TODAY_SALES',
  STATISTICAL_UPDATE_TODAY_CARS_SALED: 'STATISTICAL_UPDATE_TODAY_CARS_SALED'
}

/**
 * Listen websocket event
 * Example: wsListeners[wsEvents.SOME_EVENT](callback)
*/
const wsListeners = (() => {
  const listeners = Object.keys(wsEvents)
    .reduce((acc, eventName) => {
      acc[eventName] = (fn) => StatisticEventEmitter.on(eventName, fn)
      return acc
    }, {})

  return listeners
})()

const wrapAction = (action) => {
  if (!wsActions.socket) {
    StatisticEventEmitter.on('connect', action)
  } else {
    action()
  }
}

const wsActions = {
  socket: null,
  ACTION_JOIN_TO_DASHBOARD: () => {
    wrapAction(() => wsActions.socket.emit('ACTION_JOIN_TO_DASHBOARD'))
  }
}

/**
 *
 * @param {Socket} socket
 */
function bindWsEvents (socket) {
  wsActions.socket = socket

  Object.keys(wsEvents).forEach(eventName => {
    socket.on(eventName, (args) => StatisticEventEmitter.emit(eventName, args))
  })
}

/**
 * Get metrics
 */
const loadMetrics = () => api.get('/statistical/metrics')

const loadAppRoutes = () => api.get('/statistical/app-routes')

const loadChartsData = (period) => {
  const query = concantQuery({ period })
  return api.get(`/statistical/charts${query}`)
}

const loadUsers = ({ limit, offset, search }) => {
  const query = concantQuery({ limit, offset, search })
  return api.get(`/statistical/users${query}`)
}
const addSeo = body => {
  return api.post("/seo", body);
};

const editSeo = (data) => {
  return api.put(`/seo/${data.seoId}`, data.seo);
};
const getSeoBypages = ({ take, skip, search  }) => {
  const query = concantQuery({ take, skip, search });
  return api.get(`/seo${query}`)
}

export {
  loadMetrics,
  loadChartsData,
  loadUsers,
  bindWsEvents,
  wsEvents,
  wsListeners,
  wsActions,
  loadAppRoutes,
  addSeo,
  getSeoBypages,
  editSeo
}
